import { Navigate, Route, Routes } from 'react-router-dom';
import { LanguageProvider } from './Context/LanguageContext';
import { WishlistProvider } from './Context/WishlistContext';

import Auth from './pages/Auth/outhoperation/Auth';
import Users from './components/Dashboard/Users';
import GoogleCallBack from './pages/Auth/outhoperation/GoogleCallBack';
import Dashboard from './pages/Dashoard/Dashboard';
import RequierAuth from './pages/Auth/protecting/RequierAuth';
import User from './pages/Dashoard/Users/User';
import AddUser from './pages/Dashoard/Users/AddUser';

import Writer from './pages/Auth/Writer';
import AdminOrders from './pages/Dashoard/Orders/AdminOrders';
import Err404 from './pages/Auth/Errors/404';
import RequierBack from './pages/Auth/protecting/RequierBack';
import Categories from './pages/Dashoard/Category/Categories';
import AddCategory from './pages/Dashoard/Category/AddCategory';
import EditCategory from './pages/Dashoard/Category/EditCategory';

import Products from './pages/Dashoard/Products/Products';
import AddProducts from './pages/Dashoard/Products/AddProducts';
import EditProducts from './pages/Dashoard/Products/EditProducts';
import HomePage from './pages/webSite/HomePage/HomePage';
import WebsiteCategories from './pages/webSite/categories/WebSiteCategories';
import CategoryProducts from './pages/webSite/categories/CategoryProducts';
import SearchResults from './pages/webSite/search/SearchResults';
import Profile from './pages/webSite/profile/Profile';
import Orders from './pages/webSite/orders/Orders';
import OrderDetail from './pages/webSite/orders/OrderDetail';
import Checkout from './pages/webSite/checkout/Checkout';
import PaymentVerify from './pages/webSite/checkout/PaymentVerify';
import PrivacyPolicy from './pages/webSite/legal/PrivacyPolicy';
import TermsConditions from './pages/webSite/legal/TermsConditions';
import RefundPolicy from './pages/webSite/legal/RefundPolicy';
import ContactUs from './pages/webSite/legal/ContactUs';
import AboutUs from './pages/webSite/legal/AboutUs';
import WebSite from './pages/webSite/WebSite';
import SingleProduct from './pages/webSite/singleProducts/singleProduct';



function App ()
{
  return (
    <LanguageProvider>
      {/* WishlistProvider يلف كل التطبيق عشان أي صفحة تقدر تستخدم useWishlist() */ }
      <WishlistProvider>
        <div className="App">
          {/* publlic route */ }
          <Routes>
            <Route element={ <WebSite /> }>


              <Route path='/' element={ <HomePage /> } />

              <Route path='/websitecategories' element={ <WebsiteCategories /> } />
              <Route path='/category/:id' element={ <CategoryProducts /> } />
              <Route path='/search' element={ <SearchResults /> } />
              <Route path='/profile' element={ <Profile /> } />
              <Route path='/orders' element={ <Orders /> } />
              <Route path='/orders/:id' element={ <OrderDetail /> } />
              <Route path='/checkout' element={ <Checkout /> } />
              <Route path='/payment/verify' element={ <PaymentVerify /> } />
              <Route path='/privacy-policy' element={ <PrivacyPolicy /> } />
              <Route path='/terms-conditions' element={ <TermsConditions /> } />
              <Route path='/refund-policy' element={ <RefundPolicy /> } />
              <Route path='/contact-us' element={ <ContactUs /> } />
              <Route path='/about-us' element={ <AboutUs /> } />
              <Route path='/product/:id' element={ <SingleProduct /> } />
            </Route>
            <Route element={ <RequierBack /> } >
              {/* صفحة واحدة موحّدة لتسجيل الدخول وإنشاء الحساب */ }
              <Route path='/auth' element={ <Auth /> } />
              {/* روابط قديمة بتتحوّل تلقائياً للصفحة الجديدة عشان ما ينكسرش أي رابط محفوظ */ }
              <Route path='/login' element={ <Navigate to="/auth" replace /> } />
              <Route path='/register' element={ <Navigate to="/auth" replace /> } />

            </Route>
            {/* protected route */ }

            <Route path='/auth/google/callback' element={ <GoogleCallBack /> } />
            <Route path='/*' element={ <Err404 /> } />

            {/* protected route  */ }
            <Route element={ <RequierAuth allowedRole={ [ "1995", "1996", "1999" ] } /> }>

              <Route path='/dashboard' element={ <Dashboard /> }>

                <Route element={ <RequierAuth allowedRole={ [ "1995" ] } /> } >

                  <Route path='users' element={ <Users /> } />
                  <Route path='users/:id' element={ <User /> } />
                  <Route path='users/add' element={ <AddUser /> } />
                </Route>
                <Route element={ <RequierAuth allowedRole={ [ "1999", "1995" ] } /> } >
                  <Route path='categories' element={ <Categories /> } />
                  <Route path='categories/:id' element={ <EditCategory /> } />
                  <Route path='category/add' element={ <AddCategory /> } />
                  {/* products */ }
                  <Route path='products' element={ <Products /> } />
                  <Route path='products/:id' element={ <EditProducts /> } />
                  <Route path="product/:id" />
                  <Route path='products/add' element={ <AddProducts /> } />
                  {/* orders */ }
                  <Route path='orders' element={ <AdminOrders /> } />
                </Route>

                <Route element={ <RequierAuth allowedRole={ [ "1996", "1995" ] } /> } >
                  <Route path='writer' element={ <Writer /> } />
                </Route>

              </Route>
            </Route>

          </Routes>

        </div>
      </WishlistProvider>
    </LanguageProvider>
  );
}

export default App;
